<template>
  <v-container fluid grid-list-md style="padding: 30px;">
    <v-row>
      <v-col cols="12" sm="12" md="6">
        <v-select outlined dense v-model="eventoId" :items="eventos" item-text="nome" item-value="id" label="Selecione o Evento" @input="carregaIndicacoes" color="#0D47A1"></v-select>
      </v-col>
    </v-row>
    <v-data-table :search="tabela.busca" :headers="tabela.cabecalho" :items="tabela.conteudo" sort-desc class="elevation-1" style="border-radius: 10px;">
      <template v-slot:top>
        <v-toolbar flat color="white" style="border-radius: 10px;">
          <v-toolbar-title class="textoUser">INDICAÇÕES REALIZADAS</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field v-model="tabela.busca" append-icon="search" label="Pesquisa" single-line hide-details></v-text-field>
        </v-toolbar>
      </template>
      <template v-slot:no-data>
        <v-row>
          <v-col>
            <v-alert dark dense text outlined :value="true" color="warning" icon="info">Nenhuma indicação realizada</v-alert>
          </v-col>
        </v-row>
      </template>
      <template slot="no-results">
        <v-row>
          <v-col>
            <v-alert dark dense text outlined :value="true" color="warning" icon="info">Sua pesquisa por "{{tabela.busca}}" não trouxe resultados</v-alert>
          </v-col>
        </v-row>
      </template>
      <template v-slot:[`item.detalhes`]="{ item }">
        <v-btn icon @click="verDetalhes(item.id)">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <v-dialog v-model="dialogoDetalhes" persistent max-width="800px" scrollable>
      <v-card>
        <v-card-title>Detalhes</v-card-title>
        <v-card-text style="padding: 0px 12px 0px 12px" v-if="tabela.conteudoDetalhes.length > 0">
          <v-row style="padding: 5px">
            <v-col cols="12" lg="6">
              <v-select
                outlined
                dense
                hide-details
                label="Setor"
                v-model="filtroSetor"
                :items="eventoSelecionado.setores"
                item-text="nome"
                item-value="nome"
                clearable
              ></v-select>
            </v-col>
            <v-col cols="12" lg="6">
              <v-select
                outlined
                dense
                hide-details
                label="Status de Pagamento"
                v-model="filtroPagamento"
                :items="tiposPagamento"
                clearable
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text style="padding: 0px 12px 0px 12px">
          <v-data-table
            :search="tabela.busca"
            :headers="tabela.cabecalhoDetalhes"
            :items="filtroItensTabela()"
            sort-desc
            class="elevation-0"
            :hide-default-header="tabela.conteudoDetalhes.length == 0"
            :hide-default-footer="tabela.conteudoDetalhes.length == 0"
          >
            <template v-slot:top>
              <v-toolbar flat color="white" style="border-radius: 10px;" v-if="tabela.conteudoDetalhes.length > 0">
                <v-text-field v-model="tabela.busca" append-icon="search" label="Pesquisa" single-line hide-details></v-text-field>
              </v-toolbar>
            </template>
            <template v-slot:no-data>
              <v-row>
                <v-col>
                  <v-alert dark dense text outlined :value="true" color="warning" icon="info">Nenhuma indicação realizada</v-alert>
                </v-col>
              </v-row>
            </template>
            <template slot="no-results">
              <v-row>
                <v-col>
                  <v-alert dark dense text outlined :value="true" color="warning" icon="info">Sua pesquisa por "{{tabela.busca}}" não trouxe resultados</v-alert>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.created`]="{ item }">
              <p style="margin: 0px">{{ transformaData(item.created, 'DD/MM/YYYY') }} às {{ transformaData(item.created, 'HH:mm:ss') }}</p>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="red" @click="dialogoDetalhes = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <loading :active.sync="isLoading" :can-cancel="true" color="#7B1FA2" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </v-container>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import moment from 'moment'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  export default {
    components: { Snackbar, Loading },
    data: () => ({
      fullPage: true,
      isLoading: false,
      addUser: false,
      temInscritos: false,
      tabela: {
        busca: '',
        cabecalho: [
          { text: 'Nome', align: 'start', value: 'nome', },
          { text: 'Total Indicações', align: 'center', value: 'totalInscricoes' },
          { text: 'Indicações Pendentes', align: 'center', value: 'pendentes' },
          { text: 'Indicações Pagas', align: 'center', value: 'pagas' },
          { text: 'Click', align: 'center', value: 'qtdClicks'},
          { text: 'Detalhes', align: 'center', value: 'detalhes' },
        ],
        cabecalhoDetalhes: [
          { text: 'Nome', align: 'start', value: 'nome', },
          { text: 'Setor', value: 'setor' },
          { text: 'Lote', value: 'lote' },
          { text: 'Status', value: 'statusPagamento' },
          { text: 'Realizada em', value: 'created' },
        ],
        conteudo: [],
        conteudoDetalhes: [],
      },
      eventos: [],
      eventoId: '',
      eventoSelecionado: [],
      dialogoDetalhes: false,
      tiposPagamento: ["CANCELADO", "ESTORNADO", "PAGO", "PENDENTE"],
      filtroSetor: '',
      filtroPagamento: '',
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
    }),

    mounted() {
      this.carregaDados()
    },

    watch: {
      dialogoDetalhes(val) {
        if (val == false) {
          setTimeout(() => {
            this.tabela.conteudoDetalhes = []
          }, 300);
        }
      },
    },

    methods: {
      async carregaDados() {
        this.isLoading = true
        await axios.get(baseApiUrl + 'Eventos?filter={"where":{"and":[{"empresaId":"'+this.companyobj.id+'"}]}}&access_token=' + sessionStorage.getItem('accToken')).then(response => {
          if (response.data) {
            for (var key in response.data) {
              if (response.data.hasOwnProperty(key)) {
                this.eventos.push(response.data[key])
              }
            }
            this.eventos = this.eventos.sort(this.compare)
            this.eventoId = this.eventos[0].id
          } else {
            this.isLoading = false
          }
        })
        await this.carregaIndicacoes()
      },

      async carregaIndicacoes() {
        for (let i = 0; i < this.eventos.length; i++) {
          if (this.eventos[i].id == this.eventoId) {
            this.eventoSelecionado = this.eventos[i]
          }
        }

        this.isLoading = true
        await axios.post(baseApiUrl + 'Divulgadores/qtdInscricoes?access_token=' + sessionStorage.getItem('accToken'), {"eventoId": this.eventoId, "empresaId": this.companyobj.id}).then(response => {
          if (response.data) {
            this.tabela.conteudo = response.data
            this.isLoading = false
          } else {
            this.isLoading = false
          }
        })
      },

      async verDetalhes(divulgadorId) {
        this.isLoading = true

        await axios.post(baseApiUrl + 'Divulgadores/detalhes', {"eventoId": this.eventoId, "divulgadorId": divulgadorId})
        .then(response => {
          if (response.data) {
            this.tabela.conteudoDetalhes = response.data
            this.dialogoDetalhes = true
          }
        })

        this.isLoading = false
      },

      filtroItensTabela() {
        if (this.filtroSetor && !this.filtroPagamento) {
          // retorna inscrições apenas com o filtro de setor
          return this.tabela.conteudoDetalhes.filter(inscricao => inscricao.setor == this.filtroSetor)
        }
        else if (!this.filtroSetor && this.filtroPagamento) {
          // retorna inscrições apenas com o filtro de pagamento
          return this.tabela.conteudoDetalhes.filter(inscricao => inscricao.statusPagamento == this.filtroPagamento)
        }
        else if (this.filtroSetor && this.filtroPagamento) {
          // retorna inscrições com filtro de setor e pagamento
          return this.tabela.conteudoDetalhes.filter(inscricao => inscricao.statusPagamento == this.filtroPagamento && inscricao.setor == this.filtroSetor)
        }
        else {
          // retorna inscrições sem filtro
          return this.tabela.conteudoDetalhes
        }
      },

      compare(a, b) {
        // Use toUpperCase() to ignore character casing
        const dataA = moment(this.formatDateHora(a.fim), 'DD/MM/YYYY HH:mm:ss', true).format()
        const dataB = moment(this.formatDateHora(b.fim), 'DD/MM/YYYY HH:mm:ss', true).format()

        let comparison = 0;
        if (dataB >= dataA) {
          comparison = 1;
        } else if (dataB < dataA) {
          comparison = -1;
        }
        
        return comparison;
      },

      formatDate(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDateBrz(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDatePadrao(date) {
        if (!date) return null

        const [day, month, year] = date.substr(0, 10).split('/')
        return `${year}-${month}-${day}` + " " + date.substr(11, 6)
      },

      formatDateHora(date) {
        if (!date) return null

        const [year, month, day] = date.substr(0, 10).split('-')
        return `${day}/${month}/${year}` + " " + date.substr(11, 8)
      },

      close() {
        this.addUser = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      transformaData(data, formato) {
        let date = moment(data).format(formato);
        return date
      },
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px;
    width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
  }
</style>